document.addEventListener("DOMContentLoaded", function() {
  var url = window.location.href;

  // Run only on collection + product URLs
  if (url.includes("/collections/") && url.includes("/products/")) {
    
    // Function to hide the elements if they exist
    function hideWheelify() {
      var el1 = document.querySelector("#wheelify");

      if (el1 && el1.style.display !== "none") {
        el1.style.setProperty("display", "none", "important");
      }
    }

    // Run once in case elements are already loaded
    hideWheelify();

    // Watch for dynamically added elements
    var observer = new MutationObserver(hideWheelify);
    observer.observe(document.body, { childList: true, subtree: true });

    // Optional: stop observing after 10 seconds (performance)
    setTimeout(() => observer.disconnect(), 10000);
  }
});
